import ImportListProductTable from './ImportListProductTable'

export default ImportListProductTable
